import {LlmRunScore, SingleTestResult} from "common/flowmaster/types/llm_run";

export const problemComplexities = [
  "find_clauses",
  "summary",
  "bounded",
  "remediation",
];
export type ProblemComplexityKey = typeof problemComplexities[number];

export type ProblemComplexity = {
  [K in ProblemComplexityKey]?: {
    keys: string[];
    extends?: ProblemComplexityKey;
  };
};

export type ScoredProblemComplexity = Partial<
  Record<ProblemComplexityKey, number>
> & {all: number};
export interface QueryDomain {
  problem_complexity: ProblemComplexity;
  question_complexity: {
    multi_clause: boolean;
    together: boolean;
    complex_definitions: boolean;
  };
  adhoc: boolean;
  scope: "single_document" | "multi_document";
  domain: "nda" | "commercial" | "real_estate" | "finance";
}

export interface TestSummary {
  results: SingleTestResult[];
}

export interface RunStatus {
  output: Record<string, unknown>;
  queryDomain: QueryDomain;
  tests?: TestSummary[];
  stats?: {
    fail: number;
    pass: number;
    pending: number;
  };
}

export interface ScoredRunStatus extends RunStatus {
  score: ScoredProblemComplexity;
}

export interface RunStatusScores {
  score: ScoredProblemComplexity;
  queryDomain: QueryDomain;
  values: ScoredRunStatus[];
}

export interface ScoredRun extends LlmRunScore {
  pass: boolean;
  tests: SingleTestResult[];
}

export interface ScoreAnalysis {
  score: number;
  runs: ScoredRun[];
}

export interface QuestionComplexity {
  name: string;
  key: string;
  value: Partial<Record<keyof QueryDomain["question_complexity"], boolean>>;
}

export const questionComplexities: QuestionComplexity[] = [
  {
    name: "Simple",
    key: "simple",
    value: {multi_clause: false, together: false, complex_definitions: false},
  },
  {
    name: "Multi-clause separate",
    key: "mc_sep",
    value: {multi_clause: true, together: false, complex_definitions: false},
  },
  {
    name: "Multi-clause Together",
    key: "mc_together",
    value: {multi_clause: true, together: true, complex_definitions: false},
  },
  {name: "Complex", key: "complex", value: {complex_definitions: true}},
];

export type GroupedScores = {
  groups: Record<
    ProblemComplexityKey,
    Record<QuestionComplexity["key"], ScoreAnalysis>
  >;
  ungrouped: LlmRunScore[];
};

export const viewModes = ["per_batch", "by_complexity"];
export type ViewMode = typeof problemComplexities[number];
